// MobileNav.js
import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import MenuItem from "./MenuItem";
import {
    Box,
    List,
    ListItem,
    Button,
    IconButton,
} from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import { FaSignOutAlt } from "react-icons/fa";
import { AuthContext } from "../contexts/AuthContext";
import { processMenuData } from "../utils/menuConfig";

function MobileNav() {
    // Hamburger Menu state
    const [mobileNavDisplay, setMobileNavDisplay] = useState(false);
    const navigate = useNavigate();
    const { menuData } = useContext(AuthContext);

    const handleLogout = () => {
        // Logout logic
        navigate("/");
    };

    const handleNavToggle = () => {
        setMobileNavDisplay(!mobileNavDisplay);
    }

    const handleMenuItemClick = () => {
        setMobileNavDisplay(false);
    };

    // Process menu data to remove duplicates and sort
    const processedMenuData = processMenuData(menuData);

    return (
        <Box display={{ base: "flex", xl: "none" }} zIndex="0">
            {!mobileNavDisplay && (
                <IconButton variant="noBorder-bgOpaque" size="lg" onClick={handleNavToggle}><HamburgerIcon /></IconButton>
            )}
            {mobileNavDisplay && (
            <List position="absolute" zIndex="1000" top="100px" right="0" bg="darkGray" w={{base: "100%", md: "25%"}} display="flex" justifyContent="end" alignItems="end" flexDirection="column">
                <IconButton p="2" variant="noBorder-bgOpaque" size="xm" onClick={handleNavToggle}><CloseIcon /></IconButton>
                {/* Dynamic Menu Items */}
                {processedMenuData.map((menuItem, index) => (
                    <MenuItem 
                        key={`mobile-${menuItem.menuCode}-${index}`} 
                        menuItem={menuItem} 
                        isMobile={true}
                        onItemClick={handleMenuItemClick}
                    />
                ))}
                {/* Sign-Out Button */}
                <ListItem w="100%" m="0 0.3em">
                    <Button
                        w="100%"
                        variant="noBorder-bgOpaque"
                        leftIcon={<FaSignOutAlt color="white" />}
                        onClick={handleLogout}
                        p="1.4em"
                    >
                        Logout
                    </Button>
                </ListItem>
            </List>
            )}
        </Box>
    );
}

export default MobileNav;
